import type { PatchAssetStateRequest } from './assetPatchState';
import apiRequest from './apiRequest';

export default async function patchMediaByID(
  apiKey: string,
  mediaID: string,
  body: PatchAssetStateRequest,
) {
  return apiRequest<Record<string, never>>(
    'external-mogen',
    `/media/${encodeURIComponent(mediaID)}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
      body: JSON.stringify(body),
    },
  );
}
